import { PersonalSetting } from '@ardoq/api-types';
import { maybeShowConfirm } from 'components/Dialogs/maybeConfirm/maybeShowConfirm';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

let pendingConfirmation: Promise<boolean> | null = null;

export const maybeShowConfirmCloseScenario = (): Promise<boolean> => {
  if (pendingConfirmation) {
    return pendingConfirmation;
  }

  // i18nLocale$.state OK here: snapshot-at-open-time; @ardoq/modal renders confirm() body once and does not re-render on locale change
  const i18nLocale = i18nLocale$.state;
  pendingConfirmation = maybeShowConfirm({
    title: t(
      i18nLocale,
      'appContainer:confirmCloseScenario.title',
      'Confirmation required'
    ),
    body: t(
      i18nLocale,
      'appContainer:confirmCloseScenario.body',
      'Closing the scenario will load your mainline. Are you sure you want to leave the scenario?'
    ),
    personalSettingKey: PersonalSetting.HIDE_ON_CLOSE_SCENARIO_WARNING,
  }).finally(() => {
    pendingConfirmation = null;
  });

  return pendingConfirmation;
};
